import { homApi } from '~/redux/apis/hom'
import { BOOTCAMP_TYPE } from '~/redux/constants/tags.const'

import { CategoriesDataVideo } from '../types/bootcamp.types'

export const videoWatchApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideoWatchLists: builder.query<{ videoStatsPerBootcampCategory: CategoriesDataVideo }, number | undefined>({
      query: () => ({
        url: '/v1/user-stats/bootcamp/video-stats',
        method: 'GET',
      }),
      providesTags: (_, __, id) => [{ type: 'VideoWatchCount', id }],
    }),
    getVideoWatchedPerBootcamp: builder.query<string[], { topic: string; subject: string; bootcampId: string }>({
      query: (params) => ({
        url: '/v1/bootcamp/video-watched',
        method: 'GET',
        params,
      }),
      providesTags: [BOOTCAMP_TYPE.BOOTCAMP_VIDEO_WATCHED],
    }),
  }),
})

export const { useGetVideoWatchListsQuery, useGetVideoWatchedPerBootcampQuery } = videoWatchApi
